export const ACTIVE = 1
export const PENDING = 2
export const INACTIVE = 3
export const DELETED = 4